import React from 'react'
import ReviewImage1 from '../img/review1.png'
import ReviewImage2 from '../img/review2.png'
import ReviewImage3 from '../img/review3.png'
import Underline from '../img/underline.webp';

const reviewDetails = [
  {
    image:ReviewImage1,
    name:"Dr. Bow Johnson",
    comment:"I have been working at Afya for over five years, and I can confidently say that it has been one of the best experiences of my career. The management team is supportive and understanding to staff.",
    rating:3
  },
  {
    image:ReviewImage2,
    name:"Nurse Hilary Tumo",
    comment:"The work environment is collaborative, and I feel valued for my contributions. The resources provided for patient care are top-notch, and the teamwork among staff is exceptional. I highly recommend.", 
    rating:4
  },
  {
    image:ReviewImage3,
    name:"Dr. Monica Katoi",
    comment: "Working at Afya has been a fulfilling experience for me. The commitment to innovation and patient care here is impressive. I appreciate the opportunity to work with cutting-edge technology.",
    rating:5
  }
]


const Team = () => {
  return (
    <>    
    <section className="mt-10 px-14 py-1" id="reviews">
      <div>
        <h1 class="text-5xl text-center font-bold max-md:text-5xl max-md:text-center max-sm:text-4xl text-[#118C5F]">OUR TEAM</h1>
        <div className='flex justify-center mt-5'>
            <img src={Underline} alt="about"/>
        </div>
      </div>  
      <div className='mt-20 grid grid-cols-1 gap-14 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1'>
        {reviewDetails.map((reviewDetail, index)=>(
          <div key={index} className='bg-transparent shadow-xl shadow-[#adadad] px-8 py-10 rounded-lg border-2 border-[#118C5F]'>
            <div>
              <div className='flex align-middle justify-center'>
                <img src={reviewDetail.image} alt="review" className='w-3/5 ' />
              </div>
              <div className='mt-5'>
                <h2 className='text-center font-bold text-xl text-[#118C5F]'>{reviewDetail.name}</h2>
                <p className='mt-5 text-justify text-sm leading-10 text-[#3d3d3d]'>{reviewDetail.comment}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      </section>
    </>
  )
}

export default Team